import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getTwitterFollowers } from '../analytics.service';
import { FiveMinutes, InitialRetryDelay } from '../constants';
export const useTwitterFollowers = ({ subdomain = getSubdomain(), startDate, endDate, interval, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        ...options,
        queryKey: analyticsKeys.twitterFollowers(subdomain, startDate, endDate, interval),
        queryFn: () => getTwitterFollowers(subdomain, startDate, endDate, interval),
        staleTime: FiveMinutes,
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
